module.exports = __webpack_public_path__ + "25a22761263af3fc42bea8f974816768.png";